var _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoBrandSport24X24 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "incon_sport24x24",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "sport",
    d: "M8,0a8,8,0,1,0,8,8A8,8,0,0,0,8,0Zm.286,2.306,2.781-1.112a7.483,7.483,0,0,1,.914.493l.007,0a7.51,7.51,0,0,1,.823.6l.022.02q.175.149.341.309l.042.041q.174.17.336.349l.027.031c.1.107.187.217.276.329l.063.08c.1.125.19.252.278.383l-.554,2.357L10.914,7.1,8.286,5Zm-6.2,1.149.063-.08q.132-.167.272-.326l.03-.034q.162-.18.335-.349c.013-.013.027-.027.04-.039q.164-.158.338-.307L3.186,2.3A7.538,7.538,0,0,1,4,1.7l.01-.007A7.491,7.491,0,0,1,4.921,1.2L7.714,2.306V5L5.087,7.1,2.359,6.194,1.8,3.837C1.893,3.707,1.986,3.58,2.081,3.456ZM1.76,12.092q-.118-.179-.225-.365l-.017-.03q-.107-.185-.2-.376l0,0a7.429,7.429,0,0,1-.351-.827v0c-.047-.133-.091-.27-.131-.407l-.014-.051q-.055-.194-.1-.391c0-.013-.006-.025-.008-.038a7.422,7.422,0,0,1-.141-.9L2.2,6.743l2.709.9.786,3.145L4.4,12.509Zm8.016,3.159c-.133.033-.27.062-.407.087l-.058.01c-.117.021-.234.039-.352.053l-.094.012c-.11.013-.22.022-.331.03l-.1.008c-.142.009-.285.014-.429.014s-.263,0-.393-.01c-.016,0-.031,0-.047,0q-.174-.01-.347-.027l-.013,0a7.6,7.6,0,0,1-.752-.12l-1.577-2.47,1.271-1.7H9.858l1.292,1.707ZM15.292,9.6l-.009.038q-.045.2-.1.391l-.014.051c-.04.137-.083.273-.131.407v0a7.405,7.405,0,0,1-.351.827l0,0q-.1.191-.2.376l-.017.03q-.107.187-.224.365l-2.631.415-1.3-1.717L11.1,7.646l2.709-.9L15.433,8.7A7.4,7.4,0,0,1,15.292,9.6Zm0,0",
    transform: "translate(4 4)",
    fill: "#999"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12327",
    "data-name": "Rectangle 12327",
    width: 24,
    height: 24,
    fill: "none"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoBrandSport24X24);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_brand_sport24x24.dbecf825af5b5be8da2c73a1411d011c.svg";